import React from 'react'
import ThemeProvider from './src/lib/ThemeProvider'
import * as Toast from "@radix-ui/react-toast"

const WrapRootElement = ({ element }) => {
  return (
    <Toast.Provider>
      <ThemeProvider>{element}</ThemeProvider>
    </Toast.Provider>
  )
}

export default WrapRootElement
